export const capitalize = str =>
  str ? str[0].toUpperCase() + str.slice(1) : '';
